import { LINK } from '@constants';
import { Box, Column, Typography } from '@viewup/ui';
import { useAutoViewingBlockGuard } from 'app/_components/AutoViewingBlock';
import { mainSwiperPaginationCss } from 'app/_components/Main/_shared/swiperPagination.const';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

const imgLists = [
  {
    link: LINK.VIEWING_CLICK,
    name: 'new_blog_follow',
    src: '/ViewupMain/new_blog_follow.png',
  },
  {
    link: LINK.VIEWING_POST_APPLY_LIST,
    name: 'new_posting',
    src: '/ViewupMain/new_posting.png',
  },
  {
    link: LINK.VIEWING_AUTO_SETTING,
    name: 'new_auto',
    src: '/ViewupMain/new_auto.png',
  },
  {
    link: LINK.VIEWING_CLICK,
    name: 'new_nkin',
    src: '/ViewupMain/new_nkin.png',
  },
  {
    link: LINK.VIEWING_CLICK,
    name: 'new_place',
    src: '/ViewupMain/new_place.png',
  },
  {
    link: LINK.VIEWING_CLICK,
    name: 'new_blog',
    src: '/ViewupMain/new_blog.png',
  },
] as { link: string; name: string; src: string; needLogin?: boolean }[];

export const NewViewing = () => {
  const router = useRouter();
  const { guard: guardAutoViewing, modal: autoViewingBlockModal } = useAutoViewingBlockGuard();

  return (
    <Column gap={16}>
      <Typography fontType='body.medium'>지금 체험해 보는 신규 뷰업</Typography>
      <Box css={mainSwiperPaginationCss} position='relative' width='100%'>
        <Swiper
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          modules={[Pagination, Autoplay]}
          pagination={true}
          spaceBetween={20}
          style={{ height: 'max-content', paddingBottom: 36, width: '100%' }}
        >
          {imgLists.map((list) => (
            <SwiperSlide
              key={list.name}
              onClick={() => {
                if (list.link === LINK.VIEWING_AUTO_SETTING && guardAutoViewing()) return;
                return router.push(list.link);
              }}
              style={{
                borderRadius: 12,
                cursor: 'pointer',
                display: 'flex',
                overflow: 'hidden',
              }}
            >
              <Image
                alt={list.name}
                height={90}
                priority
                src={list.src}
                style={{
                  height: 'auto',
                  width: '100%',
                }}
                unoptimized
                width={392}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      {autoViewingBlockModal}
    </Column>
  );
};
